var _filter, _clipPath, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.2,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.5 24 C 47.5 36.980469 36.980469 47.5 24 47.5 C 11.019531 47.5 0.5 36.980469 0.5 24 C 0.5 11.019531 11.019531 0.5 24 0.5 C 36.980469 0.5 47.5 11.019531 47.5 24 Z M 47.5 24 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.648438 33.839844 C 20.398438 33.839844 20.148438 33.75 19.949219 33.570312 C 19.519531 33.183594 19.484375 32.523438 19.871094 32.097656 L 27.136719 23.996094 L 19.871094 15.90625 C 19.484375 15.476562 19.519531 14.816406 19.949219 14.433594 C 20.378906 14.046875 21.039062 14.082031 21.425781 14.511719 L 29.941406 24 L 21.425781 33.492188 C 21.21875 33.722656 20.933594 33.839844 20.648438 33.839844 Z M 20.648438 33.839844 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowRight);
export default __webpack_public_path__ + "static/media/slider_arrow_right.4bde3daecd0f08ce26df57010341c9da.svg";
export { ForwardRef as ReactComponent };